import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  changePassword,
  login,
  logout,
  verifyAdminPassword,
} from "src/services/auth.service";
import { RootState } from "../store";
import { resetAuthState } from "./auth.slice";
import { toast } from "sonner";

// login
export const doLogin = createAsyncThunk(
  "auth/login",
  async (body: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const response = await login(body);
      return response;
    } catch (error: any) {
      console.error("Login error:", error);
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// change password
export const doChangePassword = createAsyncThunk(
  "auth/changePasswrod",
  async (body: any, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const token = state.auth.token;
    if (!token) {
      throw new Error("Authentication token not found");
    }
    try {
      const response: any = await changePassword(token, body);
      return response;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(
        error.response?.data?.message || "Failed to change password"
      );
    }
  }
);

// logout
export const doLogout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState() as RootState;
      const token = state.auth.token;

      if (!token) {
        dispatch(resetAuthState());
        return rejectWithValue("No token found");
      }

      const response = await logout(token);
      dispatch(resetAuthState());
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Logout failed");
    }
  }
);

// verify admin password
export const doVerifyAdminPassword = createAsyncThunk<
  any,
  { password: string },
  { rejectValue: string; state: RootState }
>("auth/verifyAdminPassword", async (body, { getState, rejectWithValue }) => {
  const state = getState();
  const token = state.auth.token;
  if (!token) throw new Error("Authentication token not found");

  try {
    const response = await verifyAdminPassword(token, body);
    return response;
  } catch (error: any) {
    toast.error(error.response.data.message);
    return rejectWithValue(
      error.response?.data?.message || "Failed to verify admin password"
    );
  }
});
